import React from 'react';
import { ImageProps } from '.';

const SvgPartnerPlus = ({ size = 64, ...props }: ImageProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={(size && Math.floor(size / 3.764705882352941)) || 17}
      fill='none'
      viewBox='0 0 64 17'
      {...props}
    >
      <path
        fill='url(#PartnerPlus_svg__a)'
        d='M0 8.5A8.5 8.5 0 0 1 8.5 0h47a8.5 8.5 0 0 1 0 17h-47A8.5 8.5 0 0 1 0 8.5Z'
      />
      <path
        fill='url(#PartnerPlus_svg__b)'
        fillOpacity={0.8}
        d='M0 8.5A8.5 8.5 0 0 1 8.5 0h47a8.5 8.5 0 0 1 0 17h-47A8.5 8.5 0 0 1 0 8.5Z'
      />
      <path
        fill='#fff'
        d='M15.31 8.971h-.872l-.58 3.529h-1.473l1.31-7.972h1.473L14.69 7.44h.871l-.251 1.531Zm-3.797 1.625c.373-.075.666-.162.88-.262l-.232 1.41c-.24.118-.552.212-.935.28a6.231 6.231 0 0 1-1.115.103H7l.235-1.429h.61l.749-4.555h-.558l.235-1.428h4.766l-.234 1.428h-.558l-.732 4.453Zm-2.222.102h.759l.748-4.555h-.758l-.749 4.555ZM22.864 10.036h-6.789l.875-5.321h6.701l-.227 1.381h-5.246l-.103.626H23.2l-.215 1.307H17.86l-.102.625h5.333l-.227 1.382Zm.201.737-.238 1.447h-7.53l.239-1.447h7.53ZM32.178 4.528l-1.31 7.972h-1.473l.648-3.94h-2.301l.25-1.52h2.3l.413-2.512h1.473Zm-5.063 6.152c.354 0 .71-.031 1.07-.094.365-.068.67-.158.916-.27l-.235 1.428a3.56 3.56 0 0 1-.926.28 6.09 6.09 0 0 1-1.107.103h-2.84l1.225-7.459h1.517l-.988 6.012h1.368ZM39.992 7.46H33.23l.18-1.093h1.14l.123-.747H33.61l.18-1.092h6.606l-.18 1.092h-1.063l-.123.747h1.142l-.18 1.092Zm-3.986-1.093h1.569l.123-.747h-1.57l-.122.747Zm4.32 1.4-.188 1.14h-7.53l.188-1.14h7.53ZM34.06 11.53h5.29l-.16.971h-6.728l.338-2.054h5.211l.045-.27h-5.23l.159-.962h6.667l-.336 2.044h-5.212l-.044.271ZM48.944 4.528l-1.31 7.972H46.16l.586-3.566h-1.08l.251-1.53h1.08l.473-2.876h1.473Zm-5.068 6.18c.349 0 .706-.034 1.072-.103.365-.068.67-.156.914-.261l-.23 1.4c-.24.118-.555.212-.944.28a6.52 6.52 0 0 1-1.15.103h-2.78l.727-4.425h2.563l.257-1.568h-2.58l.234-1.42h4.044l-.721 4.388h-2.563l-.263 1.606h1.42ZM53.308 7.562a6.473 6.473 0 0 1-1.842 1.503c-.675.36-1.362.544-2.06.55l.245-1.493c.494 0 .987-.153 1.478-.457.499-.312.947-.741 1.345-1.289.4-.554.7-1.179.901-1.876l1.458.252a7.358 7.358 0 0 1-.67 1.578L57 8.374l-.986 1.279-2.706-2.091Zm-4.236 3.183h7.53l-.243 1.475h-7.53l.243-1.475Z'
      />
      <defs>
        <linearGradient id='PartnerPlus_svg__a' x1={56} x2={10.5} y1={0} y2={17} gradientUnits='userSpaceOnUse'>
          <stop stopColor='#6E5BE6' />
          <stop offset={1} stopColor='#B05BF4' />
        </linearGradient>
        <linearGradient id='PartnerPlus_svg__b' x1={25} x2={20.5} y1={0} y2={20} gradientUnits='userSpaceOnUse'>
          <stop stopColor='#6E5BE6' />
          <stop offset={1} stopColor='#B05BF4' />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default SvgPartnerPlus;
